import { STAGING_PRODUCT_KINDS } from 'constants/product'
import { RealEstatePropertyAssignmentDTO } from 'models/property'

export const groupPropertyAssignmentsWithStaging = (data: RealEstatePropertyAssignmentDTO[] | null) => {
  if (!data?.length) return []

  return Object.values(
    data.reduce((acc: Record<string, { orderId: number | string; assignments: RealEstatePropertyAssignmentDTO[] }>, assignment) => {
      const { orderId } = assignment
      if (!acc[orderId]) {
        acc[orderId] = {
          orderId,
          assignments: []
        }
      }
      acc[orderId].assignments.push(assignment)
      return acc
    }, {} as Record<string, { orderId: string; assignments: RealEstatePropertyAssignmentDTO[] }>)
  ).filter(group => group.assignments.some(assignment => STAGING_PRODUCT_KINDS.has(assignment.primaryProduct?.kind)))
}
